const PROJECT_NAME = "WDAWAM";
const PROJECT_LOGO = "../logo.png";
const PROJECT_DESC = "";
const DASH_DUMMY = "./dash-dummy.png";

const config = { PROJECT_DESC, PROJECT_LOGO, PROJECT_NAME, DASH_DUMMY };
export default config;
